<template>
  <div id="home-saude">
    <v-container>
      <v-card
        class="py-4 px-1"
        tile
      >
        <page-title
          main="Painel"
          icon="mdi-pencil-box-outline"
          sub="Gestão Saúde"
          home="/"
        />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
export default {
  name: 'HomeSaude',
  components: { PageTitle },
  data: () => ({

  })
}
</script>
